import { Entry } from 'contentful'
import { IInTheWild } from '@components/category/InTheWild/InTheWild'
import { IContentfulInTheWild } from '../../../../types/contentful/inTheWild'
import { getPosts } from '@utils/ghost'

export const parseInTheWild = async (
  component: Entry<IContentfulInTheWild>
): Promise<IInTheWild> => {
  const ghostPosts = await getPosts({
    limit: 9,
    tagSlug: component?.fields?.tagSlug || 'inspo',
  })

  const inTheWild: IInTheWild = {
    id: component?.sys?.id,
    componentKey: 'wild',
    title: component?.fields?.title,
    titleColor: component?.fields?.titleColor,
    titleSize: component?.fields?.titleSize,
    subtitle: component?.fields?.subTitle,
    subtitleColor: component?.fields?.subTitleColor,
    submenuLabel: component?.fields?.submenuLabel,
    description: component?.fields?.description,
    posts:
      ghostPosts?.map((post) => {
        return {
          feature_image: post?.feature_image,
          slug: post?.slug,
        }
      }) || [],
    streamingVideos: component?.fields?.streamingVideos?.map(
      (streamingVideo) => streamingVideo.fields
    ),
  }

  return inTheWild
}
